import React, { Suspense } from 'react';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';

import { LoadingSearchOverview } from './components/loading-search-overview';
import { PageTopBar } from './components/page-top-bar';
import { SearchOverview } from './components/search-overview';
import * as Styled from './search.style';

export const Search: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.SearchResults, undefined);

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar />

          <Styled.Content>
            <Suspense fallback={<LoadingSearchOverview />}>
              <SearchOverview />
            </Suspense>
          </Styled.Content>
        </Styled.MainContent>
      </Styled.Main>
    </Styled.Container>
  );
};
